import { memo } from 'react';
import { useToggle } from '@dfl/hook-utils';
import { DropDown, IconButton } from '@dfl/mui-react-common';
import { FileDownloadOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { IOrder } from '../../interfaces/IOrder';
import OrderExportDelivery from '../OrderExportMenu/OrderExportDelivery';
import OrderExportTracking from '../OrderExportMenu/OrderExportTracking';

type SuborderExportMenuProps = {
  order: IOrder;
  title?: string;
  variant?: 'button' | 'icon';
};

const SuborderExportMenu = ({ order, title, variant = 'button' }: SuborderExportMenuProps) => {
  const { t } = useTranslation('order');
  const { isOpen, onOpen, onClose } = useToggle();

  if (!order) return null;

  const content = [
    <OrderExportDelivery key='delivery' orderId={order?._id || ''} path={`/suborders/export/${order?._id as string}/delivery`} />,
    <OrderExportTracking
      key='tracking'
      orderId={order?._id || ''}
      path={`/suborders/export/${order?._id as string}/tracking-page`}
    />,
  ];

  if (variant === 'button') {
    return (
      <DropDown
        label={title || t('common:export')}
        buttonProps={{
          variant: 'outlined',
          startIcon: <FileDownloadOutlined />,
        }}
        open={isOpen}
        onOpen={onOpen}
        onClose={onClose}
      >
        {content}
      </DropDown>
    );
  }

  return (
    <DropDown
      label={
        <IconButton tooltip={t('common:export')} disableRipple disableTouchRipple disableFocusRipple>
          <FileDownloadOutlined />
        </IconButton>
      }
      buttonProps={{
        variant: 'text',
        endIcon: null,
        sx: {
          minWidth: 0,
          padding: 0,
          width: 40,
          height: 40,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
      open={isOpen}
      onOpen={onOpen}
      onClose={onClose}
    >
      {content}
    </DropDown>
  );
};

export default memo(SuborderExportMenu);
